import { Button, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import MainContainer from '../../layout/MainContainer';
import { VEHICLE_TYPE } from '../../utils/enums';

const AddRegionalSpec = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [image, setImage] = useState('');
  const [vehicleType, setVehicleType] = useState<any>('default');

  const handleVehicleType = (event: SelectChangeEvent) => {
    setVehicleType(event.target.value as any);
  };

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? 'Edit' : 'Add'} Regional Specification</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> -{' '}
            <span onClick={() => navigate('/vehicle-specifications/regional-specifications')}>
              Vehicle Specifications
            </span>{' '}
            -{' '}
            <span onClick={() => navigate('/vehicle-specifications/regional-specifications')}>
              Regional Specifications
            </span>{' '}
            - {id ? 'Edit' : 'Add'}
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            <div className="control_group w_50">
              <label>Select Vehicle Type</label>
              <Select
                fullWidth
                labelId="vehicleType"
                id="vehicleType"
                value={vehicleType}
                onChange={handleVehicleType}
              >
                <MenuItem disabled value="default">
                  Select Vehicle Type
                </MenuItem>
                <MenuItem value={VEHICLE_TYPE.CAR}>Car</MenuItem>
                <MenuItem value={VEHICLE_TYPE.BIKE}>Bike</MenuItem>
                <MenuItem value={VEHICLE_TYPE.TRUCK}>Truck</MenuItem>
                <MenuItem value={VEHICLE_TYPE.HEAVY_VEHICLE}>Heavy Vehicle</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Regional Spec</label>
              <TextField
                variant="outlined"
                placeholder="Regional Spec"
                fullWidth
                hiddenLabel
                // value={fullName}
                // onChange={(e) => setFullName(e.target.value)}
              />
              {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
            </div>
          </div>

          <div className="form_end_btn">
            <Button
              className="btn btn_secondary"
              onClick={() => navigate('/vehicle-specifications/regional-specifications')}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddRegionalSpec;
